import {environment} from '../../environments/environment';
import {inject, Injectable} from '@angular/core';
import {isSupported, onMessage, register, onRegistered, unregister} from 'firebase/messaging';
import {FIREBASE_MESSAGING} from '../app.firebase';
import {LocalStorageService} from './storage.service';
import {StorageService} from '@kilobytelab/core';
import {ApiAppService} from '@kilobytelab/domain';
import {AlertController} from '@ionic/angular/standalone';
import {AppService} from './app.service';
import {CONFIG} from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class PushService {

  private apiApp = inject(ApiAppService);
  public messaging = inject(FIREBASE_MESSAGING);
  private localstorage = inject(LocalStorageService);
  private storage = inject(StorageService);
  private alertCtrl = inject(AlertController);
  private appService = inject(AppService);

  constructor() {
    this.escucharRegistroFirebase();
  }

  getPermissionStatus = (): NotificationPermission => Notification.permission;

  areNotificationsSupported = (): Promise<boolean> => isSupported();

  deleteToken = () => unregister(this.messaging);

  private escucharRegistroFirebase = () => {
    onRegistered(this.messaging, async fid => {
      if (Notification.permission !== 'granted') return;
      try {
        const tokenUser = await this.storage.getToken();
        if (!tokenUser) return;
        const pushTokenGuardado = await this.localstorage.getTokenPush();
        if (!pushTokenGuardado || pushTokenGuardado !== fid) {
          await this.apiApp.setTokenPush(fid);
          await this.localstorage.setTokenPush(fid);
        }
      } catch (err) {
        console.error('Error procesando el FID de Firebase:', err);
      }
    });
  }

  requestPushNotificationsPermission = async () => {
    try {
      if (!environment.production) return;
      const supported = await this.areNotificationsSupported();
      if (!supported) return;
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return;
      await register(this.messaging, {vapidKey: CONFIG.firebase.vapidKey})
    } catch (err) {
      console.error(err)
    }
  }

  notificacionesForeground = async () => {
    const supported = await this.areNotificationsSupported();
    if (!supported) return;
    onMessage(this.messaging, async payload => {
      const alert = await this.alertCtrl.create({
        header: payload.data?.['title'] || 'Nuevo aviso',
        message: payload.data?.['body'] || '',
        buttons: [{text: 'OK', cssClass: 'primary-sec'}]
      });
      await alert.present();
      this.appService.pushRecibidoTrigger.update(n => n + 1)
    })
  }
}